// src/routes/SuperAdminRoute.jsx
import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

const SUPER_ADMIN_ROLE = import.meta.env.VITE_SUPER_ADMIN_ROLE
const DEVELOPER_ROLE = import.meta.env.VITE_DEVELOPER_ROLE

const SuperAdminRoute = () => {
  const { user } = useAuth()

  return (user?.role === SUPER_ADMIN_ROLE || user?.role === DEVELOPER_ROLE)
    ? <Outlet />
    : <Navigate to="/dashboard" replace />
}

export default SuperAdminRoute
